import { render, staticRenderFns } from "./DCarouselPagingButtons.vue?vue&type=template&id=9eac5ede&scoped=true&"
import script from "./DCarouselPagingButtons.vue?vue&type=script&lang=js&"
export * from "./DCarouselPagingButtons.vue?vue&type=script&lang=js&"
import style0 from "./DCarouselPagingButtons.vue?vue&type=style&index=0&id=9eac5ede&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9eac5ede",
  null
  
)

export default component.exports